import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { fromWhere } from 'src/app/components/encrypted-login/encrypted-login.component';
import { Breadcrumb } from 'src/app/libs/breadcrumb/breadcrumb.service';
import { UserModel } from 'src/app/models/profile.model';
import { AuthStore } from 'src/app/services/auth.store';
import { CommonService } from 'src/app/services/common.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SafeLockService } from 'src/app/services/safelock.service';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as SgeCrypto from 'src/assets/lib/sge/sge-crypto';
export let isSafeLockEnable = false;

@Component({
  selector: 'app-login-screen',
  templateUrl: './login-screen.component.html',
  styleUrls: ['./login-screen.component.scss'],
})
export class LoginScreenComponent implements OnInit {
  @ViewChild('passwordInput') passwordInput!: ElementRef;
  subscription = new Subscription();
  isSafelockActivated = false;
  isSafelockEnabled = false;
  isAuthenticated = false;

  avatarLink = 'assets/images/suite/groups/group_picture.svg';
  user!: UserModel;
  previousUrl = '';

  breadcrumbs: Breadcrumb[] = [
    {
      label: this.commonService.getTranslatedMessage('MY_ENCRYPTED_STORAGE'),
      url: '/şifreli-depo',
    },
  ];

  constructor(
    private authStore: AuthStore,
    private commonService: CommonService,
    private notificationService: NotificationService,
    private router: Router,
    public safeLockService: SafeLockService,
  ) {
    this.subscription.add(authStore.user$.subscribe((user) => (this.user = user)));
  }

  ngOnDestory(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.commonService.breadcrumbs$.next(this.breadcrumbs);
    setTimeout(() => {
      this.passwordInput && this.passwordInput.nativeElement.focus();
    }, 100);
  }

  enableSafeLock(): void {
    const pass = document.getElementById('txtSgeAktivasyonSifre') as HTMLInputElement;
    this.safeLockService
      .enableSafeLock(this.user.email, pass.value)
      .then(() => {
        isSafeLockEnable = true;
        this.authStore.setSafeLockEnabled(true);
        if (fromWhere === 'trash' || this.commonService.fromWhere === 'trash') {
          this.router.navigateByUrl('/cop-kutusu');
        } else if (fromWhere === 'favorite' || this.commonService.fromWhere === 'favorite') {
          this.router.navigateByUrl('/favorilerim');
        } else if (
          fromWhere === 'sharedToMeHistory' ||
          fromWhere === 'mySharesHistory' ||
          this.commonService.fromWhere === 'sharedToMeHistory' ||
          this.commonService.fromWhere === 'mySharesHistory'
        ) {
          this.router.navigateByUrl('/paylasimlar');
        } else if (fromWhere === 'sharedToMe' || this.commonService.fromWhere === 'sharedToMe') {
          this.router.navigateByUrl('/paylasimlar/paylasilanlar');
        } else if (fromWhere === 'myShares' || this.commonService.fromWhere === 'myShares') {
          this.router.navigateByUrl('/paylasimlar/paylastiklarim');
        } else if (fromWhere === 'recents' || this.commonService.fromWhere === 'recents') {
          this.router.navigateByUrl('/yakin-tarihli');
        } else {
          this.router.navigateByUrl('/sifreli-depo/liste');
        }
      })
      .catch(() => {
        this.authStore.setSafeLockEnabled(false);
        pass.value = '';
      });
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.enableSafeLock();
    }
  }

  forgotSgePassword(): void {
    const { user } = this;

    SgeCrypto.requestCryptoPasswordReset(user.email).then(
      () => {
        const notification = {
          message: this.commonService.getTranslatedMessage('ENCRYPTED_STORAGE_PASSWORD_RESET_REQUEST_RECIEVED'),
        };
        this.notificationService.successNotification(notification);
      },
      (reject: any) => {
        let message = reject.toString();
        message = message.replace('Error: ', '');
        message = JSON.parse(message);
        if (message.causedBy.error === 'RESET_REQUEST_ALREADY_EXISTS') {
          const notification = {
            message: this.commonService.getTranslatedMessage('HAVE_ENCRYPTED_STORAGE_PASSWORD_RESET_REQUEST'),
          };
          this.notificationService.warningNotification(notification);
        } else {
          const notification = {
            message: this.commonService.getTranslatedMessage('ENCRYPTED_STORAGE_PASSWORD_RESET_REQUEST_FAILED'),
          };
          this.notificationService.errorNotification(notification);
        }
      },
    );
  }
}
